import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { AppContext } from 'context';
import history from 'helpers/history';
import { useProgressSuccess } from 'hooks';
import Button from 'components/Form/Button';
import ButtonsContainer from 'components/Form/ButtonsContainer';
import App from 'modules/App';
import { SET_PASSWORD_FORM } from '../../constants';
import * as selectors from '../../selectors';
import Validator from '../../AccountValidator';
import validatorRules from './validatorRules.json';
const Actions = ({ isOneLiner = false })=>{
    const { getUrl } = useContext(AppContext);
    const formValues = useSelector(App.selectors.formSelector(SET_PASSWORD_FORM));
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const isInProgress = useSelector(selectors.isSetPasswordInProgress);
    const hasErrors = useSelector(selectors.hasSetNewPasswordErrors);
    const loadedIdentity = useSelector(selectors.loadedIdentity);
    const isFormNotCompleted = App.hooks.useIsFormNotCompleted(formValues, validatorRules);
    const isPasswordValid = App.hooks.useIsPasswordValid(formValues, validatorRules, {
        Validator
    });
    const isAuthenticated = !!loadedIdentity;
    let routeName = 'sign-in';
    if (isMobileDisplayMode) routeName = 'host-mobile';
    else if (isAuthenticated) routeName = 'personal-information';
    const backUrl = getUrl(routeName);
    const onSuccess = ()=>history.push(backUrl);
    useProgressSuccess(isInProgress, hasErrors, onSuccess);
    const Container = isOneLiner ? ButtonsContainer : React.Fragment;
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                isAuthenticated && /*#__PURE__*/ _jsx("div", {
                    className: "col-12 col-sm-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "link",
                        to: backUrl,
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.cancel,
                        className: "btn--block"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn('col-12', {
                        'col-sm-6': isAuthenticated
                    }),
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        styleModifier: "primary",
                        className: "btn--block btn--filled",
                        labelMessage: App.messages.buttons.continue,
                        isDisabled: isFormNotCompleted || !isPasswordValid,
                        isInProgress: isInProgress
                    })
                })
            ]
        })
    });
};
export default /*#__PURE__*/ memo(Actions);
